import React from "react";
import FlexBox from "ui/FlexBox";
import Cell, { CellProps } from "./Cell";
import useFeeColor from "hooks/useFeeColor";
import styled from "styled-components";
import Body from "ui/Text/Body";
import Link from "ui/Link";
import { stopPropagation } from "utils/dom";
import { Fee } from "interfaces/content";

interface Props extends Omit<CellProps, "value"> {
  fees: Array<Fee>;
}

const OFFSET_TO_ADD_PLUS_SIGN = 2;

const FeeCell: React.FC<Props> = ({ fees, ...other }) => {
  const { getFeeColor } = useFeeColor();

  return (
    <Cell
      {...other}
      value={
        <>
          {fees.map((fee, feeIndex) =>
            Array.isArray(fee.name) ? (
              <FlexBox key={feeIndex}>
                {fee.name.map((feeName, feeNameIndex) => (
                  <>
                    <FeeText
                      key={feeNameIndex}
                      variant="body3"
                      feeColor={getFeeColor(feeName)}
                    >
                      <Link onClick={stopPropagation} href={fee.url}>
                        {feeName}
                      </Link>
                    </FeeText>
                    {feeNameIndex <= fee.name.length - OFFSET_TO_ADD_PLUS_SIGN && (
                      <Body
                        key={`${feeNameIndex}-sign`}
                        variant="body3"
                        color="secondary"
                      >
                        &nbsp;+&nbsp;
                      </Body>
                    )}
                  </>
                ))}
              </FlexBox>
            ) : (
              <FeeText key={feeIndex} variant="body3" feeColor={getFeeColor(fee.name)}>
                <Link onClick={stopPropagation} href={fee.url}>
                  {fee.name}
                </Link>
              </FeeText>
            ),
          )}
        </>
      }
    />
  );
};

export default FeeCell;

const FeeText = styled(Body)<{ feeColor: string }>`
  color: ${({ feeColor }) => feeColor};
`;
